import {createResourceMachine} from '$lib/utils/resources/create-resource-machine';
import {createResource} from '$lib/utils/resources/create-resource';

import type {ServiceProvider} from '$types/entities/service-provider';

import {appConfig} from '$lib/configs';

const {get: getServiceProvider} = createResource({
  endpoint: `${appConfig.apiBaseUrl}/.netlify/functions/service-providers`,
});

const machine = createResourceMachine<ServiceProvider, {id: string}>(
  'service-providers',
).withConfig({
  services: {
    get: () => getServiceProvider(),
  },
});

export {machine};
